import { Role, OrgType } from '@/shared/types/userRoleTypes';
import { Customer } from './customerTypes';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type OverageType = 'FREE' | 'DATA_BLOCK';

export type AccountType = 'SUBSCRIPTION' | 'DATAPOOL';

// Region Interface
export interface Region {
  regionCode: string;
  name: string;
}

export interface UserClaims {
  organizationId: string;
  sub: string;
  orgType: OrgType;
  role: Role;
  contextOrganizationId: string;
  permissions: string[];
  scope: string;
  membershipId: string;
  exp: number;
  iat: number;
  email: string;
}

// User Interface
export interface User {
  userId: string;
  name: string;
  email: string;
  role?: Role | null;
  availableRegions?: Region[] | null;
  organizations?: Organization[] | null;
  passwordChangeRequired?: boolean | null;
  canAccessGlobalDashboard?: boolean | null;
  claims?: UserClaims | null;
}

// User registration function
export interface CreateUserData {
  name: string;
  email: string;
  role: Role;
}

// Update User Data Interface
export interface UpdateUserOrganizationsData {
  organizations: { organizationId: string; role: Role; isDefault: boolean }[];
  canAccessGlobalDashboard?: boolean;
}

export interface CreateCustomerUserData {
  name: string;
  email: string;
  role: Role;
}

export interface UpdateCustomerUserData {
  role: Role;
}

// Organization Interface
export interface Organization {
  organizationId: string;
  name: string;
  organizationType: OrgType | null;
  accountType: AccountType | null;
  overageType: OverageType | null;
  role: Role;
  isDefault: boolean;
  regionCode: string | null;
  country: string | null;
  isKYCRequiredForServiceLines: boolean | false; // Default to false if not set
  isSelfServiceAllowed: boolean | false;
  parentOrganizations?: Organization[] | null;
  hasServiceLine?: boolean | null;
  isNotificationAllowed: boolean | false;
  isServiceAccountAllowed: boolean | false;
}

export function organizationToCustomer(organization: Organization): Customer {
  return {
    customerId: organization.organizationId,
    name: organization.name,
    role: organization.role,
    isSelfServiceAllowed: organization.isSelfServiceAllowed,
  };
}